import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.interval = null;
        this.services = this.el.querySelectorAll('.o-services__list__item');
        this.active = this.services[0];

        this.active.classList.add('is-active');

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.intersectionRatio > 0) {
                    this.el.classList.add('is-visible');
                    this.activateService();
                } else {
                    this.el.classList.remove('is-visible');
                    this.deActivateService();
                }
            });
        });

        observer.observe(this.el);

        this.services.forEach((service) => {
            service.addEventListener('mouseenter', () => {
                if (service.classList.contains('is-active')) {
                    this.deActivateService();
                }
            });
            service.addEventListener('mouseleave', () => {
                if (service.classList.contains('is-active')) {
                    this.activateService();
                }
            });
            service.addEventListener('mousemove', () => {
                if (service.classList.contains('is-active')) {
                    this.deActivateService();
                }
            });

            service.querySelector('.o-services__list__item__title').addEventListener('click', () => {
                this.deActivateService();
                this.services.forEach((service) => {
                    service.classList.remove('is-active');
                });
                service.classList.add('is-active');
                this.active = service;
            });
        });

    }

    activateService() {
        this.el.classList.remove('reset-progress');
        clearInterval(this.interval);
        this.interval = null;
        this.interval = setInterval(() => {
            if (this.el.classList.contains('is-visible')) {
                this.active = this.el.querySelector('.is-active');
                this.next = this.active.nextElementSibling;
                if (this.next) {
                    this.active.classList.remove('is-active');
                    this.next.classList.add('is-active');
                } else {
                    this.active.classList.remove('is-active');
                    this.services[0].classList.add('is-active');
                }
            }
        }, 5000);
    }

    deActivateService() {
        clearInterval(this.interval);
        this.interval = null;
        this.el.classList.add('reset-progress');
    }

    destroy() {
        clearInterval(this.interval);
        this.services.forEach((service) => {
            service.removeEventListener('mouseenter');
            service.removeEventListener('mouseleave');
            service.removeEventListener('mousemove');
            service.querySelector('.o-services__list__item__title').removeEventListener('click');
        });
    }
}
